function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-restricted-syntax */

/* eslint-disable max-statements */

/* eslint-disable complexity */

/* eslint-disable max-params */
var GROUP_PADDING = 16;
var GROUP_TITLE = 13.44;
var SEPARATOR = 17;

function isGroup(opts) {
  return opts.length && opts[0].type.name === 'Group';
}

function countOptions(opts) {
  var count = opts.length;

  if (isGroup(opts)) {
    if (opts.length === 1) {
      count = opts[0].props.options.length;
    } else {
      count = opts.reduce(function (o1, o2) {
        return o1.props.options.length + o2.props.options.length;
      });
    }
  }

  return count;
}

var useMenuListHeight = function useMenuListHeight(elements, maxElements, itemSize, remainingHeight) {
  var amountOfOptions = countOptions(elements);
  var elementSlotsToShow = amountOfOptions < maxElements || !maxElements ? amountOfOptions : maxElements;
  var calculatedHeight = itemSize * elementSlotsToShow;

  if (elementSlotsToShow === 1) {
    var _elements$, _elements$$props, _elements$$props$data;

    if ((_elements$ = elements[0]) !== null && _elements$ !== void 0 && (_elements$$props = _elements$.props) !== null && _elements$$props !== void 0 && (_elements$$props$data = _elements$$props.data) !== null && _elements$$props$data !== void 0 && _elements$$props$data.hasSeparator) calculatedHeight += 40;else calculatedHeight += 25;
  } // add pixels for group type (title and padding)


  if (isGroup(elements)) {
    var groupElementsShowed = 0;

    var _iterator = _createForOfIteratorHelper(elements),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _currentOptions$props, _currentOptions$props2, _currentOptions$props3, _currentOptions$props4;

        var group = _step.value;

        if (groupElementsShowed >= elementSlotsToShow) {
          break;
        }

        var currentOptions = group;
        groupElementsShowed += (currentOptions === null || currentOptions === void 0 ? void 0 : (_currentOptions$props = currentOptions.props) === null || _currentOptions$props === void 0 ? void 0 : (_currentOptions$props2 = _currentOptions$props.options) === null || _currentOptions$props2 === void 0 ? void 0 : _currentOptions$props2.length) || 0;
        calculatedHeight += GROUP_PADDING + GROUP_TITLE;

        if (currentOptions !== null && currentOptions !== void 0 && (_currentOptions$props3 = currentOptions.props) !== null && _currentOptions$props3 !== void 0 && (_currentOptions$props4 = _currentOptions$props3.data) !== null && _currentOptions$props4 !== void 0 && _currentOptions$props4.hasSeparator) {
          calculatedHeight += SEPARATOR;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  var height;

  if (maxElements) {
    height = calculatedHeight;
  } else if (remainingHeight > calculatedHeight) {
    height = calculatedHeight;
  } else {
    height = remainingHeight;
  }

  return height;
};

export { useMenuListHeight };
//# sourceMappingURL=useMenuListHeight.js.map
